import { Component, OnInit, Input } from '@angular/core';
import { Familiares } from '../../../../models/familiares';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfigDataService } from '../../../../services/config-data.service';
import { PersonalService } from '../../../../services/personal.service';
import {MyValidations} from '../../../../utils/my-validations';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-familiar-detalle',
  templateUrl: './familiar-detalle.component.html',
  styleUrls: ['./familiar-detalle.component.css']
})
export class FamiliarDetalleComponent implements OnInit {

  constructor(private configDataSrv: ConfigDataService,
              private personalService: PersonalService, 
              private fb: FormBuilder) { }

  @Input() set familiar(familiarRecibido: Familiares)
  {
    this.familiarForm = familiarRecibido;
    this.setearForm(familiarRecibido);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() familiaresInvalida: boolean;
  @Input() nacimientoposterior: boolean;

  form: FormGroup;
  clasesFamiliarList: any;
  sexosList: any;
  clasesDocList: any;
  paisesList: any;
  nacionalidadesList: any;
  estadoCivilList: any;
  submitted: boolean;
  familiarForm: Familiares;
  formHabilitado: boolean;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.configDataSrv.getDatosFamiliares()
      .subscribe(
        data => {
          this.clasesFamiliarList=data["ClaseFamiliar"];
          this.sexosList=data["Sexos"];
          this.paisesList=data["Paises"];
          this.nacionalidadesList=data["Nacionalidad"];
          this.clasesDocList=data["ClaseDocumentos"];
          this.estadoCivilList=data["EstadoCivil"];
        },
        error => {
          console.log(error);
        });

    this.configurarValidadores();
    this.setearForm(this.familiarForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      personal: ['', Validators.required],
      claseFamilia: ['', Validators.required],
      nacionalidad: ['', Validators.required],
      nombre: ['', [Validators.required, Validators.pattern(/^[\p{L}\s]+$/u)]],
      apellido: ['', [Validators.required, Validators.pattern(/^[\p{L}\s]+$/u)]],
      segundoApellido: ['', Validators.pattern(/^[\p{L}\s]+$/u)],
      sexo: ['', Validators.required],
      claseDocumento: ['', Validators.required],
      docNro: ['', Validators.required],
      fechaNacimiento: ['', Validators.required],
      pais: ['', Validators.required],
      estadoCivil: ['', Validators.required],
      celular: ['', Validators.required],
      email: ['', Validators.required],
      discapacitado: [''],
      contactoEmergencia: [''],
      presentacionCertificado: ['']
    });
  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(familiar: Familiares)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(familiar?.id);
      this.form.controls['desde'].setValue(new Date(familiar?.desde));
      this.form.controls['hasta'].setValue(new Date(familiar?.hasta));
      this.form.controls['personal'].setValue(familiar?.personal);
      this.form.controls['claseFamilia'].setValue(familiar?.claseFamilia);
      this.form.controls['nombre'].setValue(familiar?.nombre);
      this.form.controls['apellido'].setValue(familiar?.apellido);
      this.form.controls['segundoApellido'].setValue(familiar?.segundoApellido);
      this.form.controls['sexo'].setValue(familiar?.sexo);
      this.form.controls['claseDocumento'].setValue(familiar?.claseDocumento);
      this.form.controls['docNro'].setValue(familiar?.docNro);
      if (familiar?.fechaNacimiento != null) {
        this.form.controls['fechaNacimiento'].setValue(new Date(familiar?.fechaNacimiento));
      }
      this.form.controls['pais'].setValue(familiar?.pais);
      this.form.controls['estadoCivil'].setValue(familiar?.estadoCivil);
      this.form.controls['discapacitado'].setValue(familiar?.discapacitado);
      this.form.controls['contactoEmergencia'].setValue(familiar?.contactoEmergencia);
      if (familiar?.presentacionCertificado != null) {
        this.form.controls['presentacionCertificado'].setValue(new Date(familiar?.presentacionCertificado));
      }
      this.form.controls['celular'].setValue(familiar?.celular);
      this.form.controls['email'].setValue(familiar?.email);
      this.form.controls['nacionalidad'].setValue(familiar?.nacionalidad);

      if (familiar.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
    }
  }

  cambioDiscapacitado(event)
  {
    if (event.checked == false) 
    {
      this.setValidatorRequired('presentacionCertificado', null);
    } else
    {
      this.setValidatorRequired('presentacionCertificado', Validators.required);
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  onChangeFechas()
  {
    this.chequeoRetro();
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.familiarForm.personal, 'Familiares', desde, hasta, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }
}
